import light from "assets/images/logos/logo.svg";
import dark from "assets/images/logos/logo.svg";
import React from "react";
import ThemeMode, { EThemeModeType } from "Stores/ThemeMode";

type IProps = {};

type IState = {
	theme: EThemeModeType;
};

export default class Logo extends React.Component<IProps, IState> {
	private removeOnSwitch = () => {};

	constructor(props: IProps) {
		super(props);
		this.state = {
			theme: ThemeMode.getInstance().type,
		};
	}

	public render(): JSX.Element {
		return <img alt="logo" src={this.getSrc()} />;
	}

	public componentDidMount() {
		this.removeOnSwitch = ThemeMode.getInstance().onSwitch((theme) => this.setState({ theme }));
	}

	public componentWillUnmount() {
		this.removeOnSwitch();
	}

	private getSrc() {
		if (this.state.theme === EThemeModeType.LIGHT) return light;
		return dark;
	}
}
